/**
 * Números oficiais do time usados pelos verificadores "Verifique o número do nosso time".
 * Fonte editável: site_config `site.team-numbers` (admin /admin/configuracoes).
 * A lista abaixo é o padrão enquanto nada foi salvo.
 */
import { useEffect, useState } from "react";

import { ensureOverridesLoaded, getOverride } from "@/lib/site-overrides";

export const TEAM_NUMBERS_KEY = "site.team-numbers";

export type TeamNumber = { numero: string; nome: string };

export const DEFAULT_TEAM_NUMBERS: TeamNumber[] = [
  { numero: "5511914693483", nome: "Ingrid Chip 1" },
  { numero: "5511933016411", nome: "Ingrid Chip 2" },
  { numero: "5511916318174", nome: "Bruna Chip 1" },
  { numero: "5511953064568", nome: "Bruna Chip 2" },
  { numero: "5511966582710", nome: "Weruska Chip 1" },
  { numero: "5511932670408", nome: "Weruska Chip 2" },
  { numero: "5511996965133", nome: "Daphne Chip 1" },
  { numero: "5511926244766", nome: "Janaína Chip 1" },
  { numero: "5511956567669", nome: "Patrícia Chip 1" },
  { numero: "5511921326196", nome: "Many Chat" },
  { numero: "5511914884041", nome: "Financeiro" },
  { numero: "5511933807726", nome: "" },
  { numero: "5511930316779", nome: "SAC" },
  { numero: "5511950814960", nome: "Secretariado" },
];

/** Números sempre reconhecidos, mesmo que a lista salva no admin não os tenha. */
export const FIXED_TEAM_NUMBERS: TeamNumber[] = [
  { numero: "5511936249889", nome: "Time FEO" },
  { numero: "5511936194544", nome: "Time FEO" },
  { numero: "5511936249799", nome: "Time FEO" },
];

/** Lista salva (ou padrão) + números fixos, sem duplicar. */
export function withFixedTeamNumbers(list: TeamNumber[]): TeamNumber[] {
  const seen = new Set(list.map((n) => n.numero));
  return [...list, ...FIXED_TEAM_NUMBERS.filter((n) => !seen.has(n.numero))];
}

/** Normaliza para 55 + DDD + número, só dígitos. */
export function normalizeTeamNumber(raw: string): string {
  const d = raw.replace(/\D/g, "");
  if (d.length === 10 || d.length === 11) return "55" + d;
  return d;
}

function readList(): TeamNumber[] {
  const v = getOverride<{ numbers?: TeamNumber[] }>(TEAM_NUMBERS_KEY);
  return withFixedTeamNumbers(Array.isArray(v?.numbers) ? v.numbers : DEFAULT_TEAM_NUMBERS);
}

/** Lista de números (só dígitos, com 55) para os verificadores. */
export function useTeamNumbers(): string[] {
  const [list, setList] = useState<TeamNumber[]>(() => withFixedTeamNumbers(DEFAULT_TEAM_NUMBERS));
  useEffect(() => {
    let alive = true;
    setList(readList());
    void ensureOverridesLoaded().then(() => alive && setList(readList()));
    return () => {
      alive = false;
    };
  }, []);
  return list.map((n) => n.numero);
}
